<div class="auth-card">
  <!-- Logo -->
  <div class="auth-logo">
    <img src="assets/images/NBHA-Norway.png" alt="NBHA Norway" />
  </div>

  @if (emailSent) {
    <!-- Success State -->
    <div class="auth-header">
      <h1>Check your email</h1>
      <p>We've sent you a reset link</p>
    </div>

    <div class="alert alert-success">
      <i class="fa fa-check-circle"></i>
      <div>
        <strong>Reset link sent!</strong>
        <p class="mb-0">We've sent a password reset link to <strong>{{ resetForm.get('email')?.value }}</strong>. Please check your inbox and follow the instructions.</p>
      </div>
    </div>

    <button
      type="button"
      class="btn btn-outline"
      routerLink="/auth/login"
    >
      <i class="fa fa-arrow-left me-2"></i>
      Back to login
    </button>
  } @else {
    <!-- Reset Form -->
    <div class="auth-header">
      <h1>Forgot password?</h1>
      <p>No worries, we'll send you reset instructions</p>
    </div>

    <form [formGroup]="resetForm" (ngSubmit)="onSubmit()">
      <!-- Email Field -->
      <div class="form-group">
        <label for="email" class="form-label">Email address</label>
        <input
          type="email"
          id="email"
          formControlName="email"
          class="form-control"
          [class.is-invalid]="resetForm.get('email')?.invalid && resetForm.get('email')?.touched"
          placeholder="you@example.com"
          required
        />
        <span *ngIf="resetForm.get('email')?.invalid && resetForm.get('email')?.touched" class="invalid-feedback">
          Please enter a valid email address
        </span>
      </div>

      <!-- Reset Button -->
      <div class="form-group">
        <button
          type="submit"
          class="btn btn-primary"
          [disabled]="resetForm.invalid || isSubmitting"
        >
          <span *ngIf="!isSubmitting">Send reset link</span>
          <span *ngIf="isSubmitting">
            <i class="fa fa-spinner spinner me-2"></i>
            Sending...
          </span>
        </button>
      </div>
    </form>

    <!-- Divider -->
    <div class="auth-divider">
      <span>or</span>
    </div>

    <!-- Back to Login -->
    <button
      type="button"
      class="btn btn-outline"
      routerLink="/auth/login"
    >
      <i class="fa fa-arrow-left me-2"></i>
      Back to login
    </button>
  }
</div>
